import {Component, HostListener, OnDestroy, OnInit} from '@angular/core';
import {UrlService} from '../../services/url.service';
import {SettingsKeyLogService} from '../../services/settings-key-log.service';
import {flatMap, takeUntil, tap} from 'rxjs/operators';

@Component({
    templateUrl: 'settings-key-log.component.html'
})
export class SettingsKeyLogComponent implements OnInit, OnDestroy {

    constructor(public settingsKeyLogService: SettingsKeyLogService,
                public urlService: UrlService) {
    }

    ngOnInit() {
        this.settingsKeyLogService.getUserRoles();
        this.settingsKeyLogService.firstTimeLoading = true;

        this.urlService.onUrlChange
            .pipe(
                tap(() => this.settingsKeyLogService.tabId = this.urlService.queryParams['tab']),
                flatMap(() => this.settingsKeyLogService.getCorporationsByQueryParams(true).pipe(takeUntil(this.urlService.instantOnUrlChange)))
            )
            .subscribe();
        this.urlService.setQueryParams('allSettingsDirectory');
    }

    ngOnDestroy() {
        this.removeAllObservers();
        this.settingsKeyLogService.resetData();
        this.urlService.resetQueryParams();
    }

    removeAllObservers() {
        this.urlService.onUrlChange.observers = [];
    }

    @HostListener('window:resize', ['$event'])
    onResize() {
        this.settingsKeyLogService.emptyRowService.fillEmptyRow();
    }
}





// WEBPACK FOOTER //
// /app/src/app/views/settings-key-log/settings-key-log.component.ts